import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Fab, Tooltip } from '@material-ui/core';
import { SettingsInputAntenna } from '@material-ui/icons';

class FormLiveDataButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        sendFunc: PropTypes.func.isRequired,
        formDisabled: PropTypes.bool,
    };

    static defaultProps = {
        formDisabled: true,
    };

    render() {
        const { sendFunc, classes, formDisabled } = this.props;

        return (
            <div className={formDisabled ? classes.firstPosition : classes.secondPosition}>
                <Tooltip title={Translator.translate('general.liveData')} placement="top">
                    <Fab
                        aria-label={Translator.translate('general.liveData')}
                        className={`${classes.btnEdit} ${classes.fabSave}`}
                        size="small"
                        onClick={sendFunc}
                    >
                        <SettingsInputAntenna className={classes.icon} />
                    </Fab>
                </Tooltip>
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 15,
        right: 240,
        [theme.breakpoints.down('md')]: {
            top: 15,
            right: 210,
        },
        [theme.breakpoints.down('sm')]: {
            top: 15,
            right: 210,
        },
        [theme.breakpoints.down('xs')]: {
            top: 15,
            right: 210,
        },
    },
    secondPosition: {
        position: 'absolute',
        top: 15,
        right: 180,
        [theme.breakpoints.down('md')]: {
            top: 15,
            right: 170,
        },
        [theme.breakpoints.down('sm')]: {
            top: 15,
            right: 170,
        },
        [theme.breakpoints.down('xs')]: {
            top: 15,
            right: 170,
        },
    },
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    btnEdit: {
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30,
        },
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem',
        },
    },
});

export default withStyles(styles, { withTheme: true })(FormLiveDataButton);



// WEBPACK FOOTER //
// ./data/components/FormLiveDataButton.js